import type { Authenticator } from "../../Authenticator/Authenticator";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { AuthenticatorImpl } from "../../Authenticator/AuthenticatorImpl";
import { AuthenticatorDataContainerImpl } from "../../AuthenticatorDataContainer/AuthenticatorDataContainerImpl";

export const createAuthenticator =
    (ctx: ContextManager) =>
    (accountSid: string): Authenticator => {
        const authenticatorDataContainer = ctx.retrieveInstanceOf(
            ContextInstance.AuthenticatorDataContainerImpl,
            AuthenticatorDataContainerImpl
        );
        authenticatorDataContainer.accountSid = accountSid;

        const auth = new AuthenticatorImpl(ctx);
        return auth;
    };
